module.exports = __webpack_public_path__ + "static/bg-brown-0c45109f8a3667c8597ec11e038e23f5.jpg";